export enum ProductListActionType {
  FETCH_PRODUCTS = "fetch_products",
  FETCH_PRODUCTS_SUCCESS = "fetch_products_success",
  FETCH_PRODUCTS_FAILURE = "fetch_products_failure",
}
